type VideoIframeLoaderOptions = {
  openBtnSelector?: string;
  iframeBoxSelector?: string;
  closeBtnSelector?: string;
  modalSelector?: string;
  titleSelector?: string;
  descSelector?: string;
};

let isVideoIframeLoaderInitialized = false;

export function initVideoIframeLoader({
  openBtnSelector = '.js-open-video-iframe',
  iframeBoxSelector = '.js-box-video-iframe',
  closeBtnSelector = '.js-close-modal',
  modalSelector = '.modal',
  titleSelector = '.js-box-title-iframe',
  descSelector = '.js-box-desc-iframe'
}: VideoIframeLoaderOptions = {}): void {
  // Защита от повторной инициализации (например, если init вызовут дважды)
  if (isVideoIframeLoaderInitialized) return;

  const hasButtons = Boolean(document.querySelector(openBtnSelector));
  const hasIframes = Boolean(document.querySelector(iframeBoxSelector));
  if (!hasButtons || !hasIframes) return;

  isVideoIframeLoaderInitialized = true;

  const clearIframe = (modalEl: HTMLElement | null): void => {
    if (!modalEl) return;

    const iframe = modalEl.querySelector<HTMLIFrameElement>(`${iframeBoxSelector} iframe`);
    if (!iframe) return;

    iframe.src = '';

    const titleEl = modalEl.querySelector<HTMLElement>(titleSelector);
    if (titleEl) titleEl.textContent = '';

    const descEl = modalEl.querySelector<HTMLElement>(descSelector);
    if (descEl) descEl.textContent = '';
  };

  document.addEventListener('click', (e: MouseEvent) => {
    const target = e.target instanceof Element ? e.target : null;
    if (!target) return;

    // ЗАГРУЗКА ВИДЕО
    const btn = target.closest(openBtnSelector) as HTMLElement | null;
    if (btn) {
      const videoSrc = btn.dataset.iframeVideo;
      const modalId = btn.dataset.modal;
      if (!videoSrc || !modalId) return;

      const modalEl = document.getElementById(modalId) as HTMLElement | null;
      if (!modalEl) return;

      const iframe = modalEl.querySelector<HTMLIFrameElement>(`${iframeBoxSelector} iframe`);
      if (!iframe) return;

      const titleText = btn.dataset.boxTitle ?? '';
      const descText = btn.dataset.boxDesc ?? '';
      const titleEl = modalEl.querySelector<HTMLElement>(titleSelector);
      if (titleEl) titleEl.textContent = titleText;
      const descEl = modalEl.querySelector<HTMLElement>(descSelector);
      if (descEl) descEl.textContent = descText;

      iframe.src = videoSrc;
      return;
    }

    // ОЧИСТКА ПО КРЕСТИКУ
    const closeBtn = target.closest(closeBtnSelector) as HTMLElement | null;
    if (closeBtn) {
      const modalEl = closeBtn.closest(modalSelector) as HTMLElement | null;
      clearIframe(modalEl);
      return;
    }

    // ОЧИСТКА ПО КЛИКУ ВНЕ iframe
    const modalEl = target.closest(modalSelector) as HTMLElement | null;
    if (!modalEl) return;

    const hasVideo = Boolean(modalEl.querySelector(iframeBoxSelector));
    if (!hasVideo) return;

    const clickedInsideVideo = target.closest(iframeBoxSelector) as HTMLElement | null;
    if (!clickedInsideVideo) clearIframe(modalEl);
  });

  // ОЧИСТКА ПО ESC
  document.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key !== 'Escape') return;

    document.querySelectorAll<HTMLElement>(modalSelector).forEach(modalEl => {
      if (!modalEl.querySelector(iframeBoxSelector)) return;
      clearIframe(modalEl);
    });
  });
}